/* eslint-disable react-refresh/only-export-components */
import type {ReactElement} from 'react';
import {useContext} from 'react';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import type {EmailMakerControl} from '../../right-panel-registry.types';
import {createDescriptorControl} from '../create-descriptor-control';
import type {SliderControlDescriptor, SliderControlInnerProps} from './slider-control.types';
import {resolveMax} from './slider-control.utils';
import {SliderContainer} from './components/slider-container/slider-container';
import {ResponsiveSliderControl} from './components/responsive-slider-control/responsive-slider-control';
import styles from './slider-control.module.scss';

function SliderControlInner({component, descriptor}: SliderControlInnerProps): ReactElement {
  const {editor} = useContext(emailMakerContext);

  const effectiveMax = editor ? resolveMax(component, descriptor) : descriptor.max;

  if (descriptor.isResponsive) {
    return (
      <div className={styles.wrapper}>
        <ResponsiveSliderControl component={component} descriptor={descriptor} effectiveMax={effectiveMax} />
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <SliderContainer activeProperty={descriptor.property} component={component} descriptor={descriptor} effectiveMax={effectiveMax} />
    </div>
  );
}

export function makeSliderControl(descriptor: SliderControlDescriptor): EmailMakerControl {
  return createDescriptorControl(SliderControlInner, descriptor);
}
